import { useEffect, useState } from 'react'
import { Container, Tab, Tabs, Card, Button, Row, Col, Badge, CardImg } from 'react-bootstrap'
import Tsn from '../../models/Tsn'
import Palette from '../../Palette'
import { useHistory, Link } from 'react-router-dom'
import TextFormatter from '../../util/TextFormatter'
import Member from "../../models/Member";
import moment from "moment";
import Swal from 'sweetalert2'

export default function TsnListPage() {
    const TAB_UPCOMING = 'UPCOMING'
    const TAB_REGISTERED = 'REGISTERED'
    const history = useHistory()
    const [tsnData, setTsnData] = useState([])
    const [registeredTsnData, setRegisteredTsnData] = useState([])
    const [activeTab, setActiveTab] = useState(TAB_UPCOMING)
    const [loading, setLoading] = useState(false)

    const fetchUpcomingTsn = async () => {
        setLoading(true)

        try {
            let memberModel = new Member()
            let result = await memberModel.getActiveMembership()

            if(moment(result?.latestRegardlessOfValidity?.valid_until).isBefore(new Date())){
                await Swal.fire({
                    title: 'Harap memproses keanggotaan saudara',
                    text: 'Keanggotaan saudara harus aktif untuk mendaftar di TSN',
                    icon: 'info',
                    confirmButtonText: 'Oke',
                })
                history.push('/member/membership')
            }

        }catch (e) {

        }

        try {
            const result = await Tsn.getAll({
                show_details: false,
                availability_conditions: 'UPCOMING',
            })
            setTsnData(result || [])
        } catch (error) {
            console.error('Error fetching TSN data:', error ? error.message : 'Unknown error')
            setTsnData([])
        } finally {
            setLoading(false)
        }
    }

    const fetchRegisteredTsn = async () => {
        setLoading(true)
        try {
            const result = await Tsn.getSelf({
                group_by: 'tsn_id',
            })
            setRegisteredTsnData(result || [])
        } catch (error) {
            console.error(
                'Error fetching registered TSN data:',
                error ? error.message : 'Unknown error',
            )
            setRegisteredTsnData([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        const isLoggedIn = !!localStorage.getItem('user')
        if (!isLoggedIn) {
            history.replace('/login')
        }
    }, [history])

    useEffect(() => {
        fetchUpcomingTsn()
    }, [])

    const handleTabSelect = (key) => {
        setActiveTab(key)
        if (key === TAB_REGISTERED && registeredTsnData.length === 0) {
            fetchRegisteredTsn()
        } else if (key === TAB_UPCOMING && tsnData.length === 0) {
            fetchUpcomingTsn()
        }
    }

    // Format date as "DD MMMM YYYY"
    function formatDate(dateString) {
        if (!dateString) return '-'
        const date = new Date(dateString)
        if (isNaN(date)) return '-'
        const months = [
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember',
        ]
        const day = String(date.getDate()).padStart(2, '0')
        const month = months[date.getMonth()]
        const year = date.getFullYear()
        return `${day} ${month} ${year}`
    }

    const TsnCards = ({ data }) => (
        <Col lg={4} md={6} className="mb-4">
            <Card className="h-100 shadow-sm position-relative">
                <CardImg style={{ maxHeight: 250, objectFit: 'cover' }} src={data?.image_url} />

                <Card.Body className="d-flex flex-column">
                    <Card.Title
                        className="mb-3 fw-semibold"
                        style={{ fontSize: '18px', color: Palette.PRIMARY }}
                    >
                        {data?.name || '-'}
                    </Card.Title>

                    <Card.Text className="">
                        {formatDate(data?.start_time) === formatDate(data?.end_time)
                            ? formatDate(data?.start_time)
                            : `${formatDate(data?.start_time)} - ${formatDate(data?.end_time)}`}
                    </Card.Text>

                    <Row className="mb-3 g-2">
                        <Col xs={6}>
                            <div
                                className="rounded py-1 text-center"
                                style={{
                                    minHeight: '40px',
                                    background: Palette.LIGHT_GRAY,
                                    border: `1px solid ${Palette.PRIMARY}`,
                                    borderRadius: 10,
                                }}
                            >
                                <small className="text-muted d-block">Lokasi</small>
                                <strong className="small">{data?.location}</strong>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div
                                className="rounded py-1 text-center"
                                style={{
                                    minHeight: '40px',
                                    background: Palette.LIGHT_GRAY,
                                    border: `1px solid ${Palette.PRIMARY}`,
                                    borderRadius: 10,
                                }}
                            >
                                <small className="text-muted d-block">Biaya</small>
                                <strong className="small">{`Rp.${TextFormatter.moneyFormatter(
                                    data?.price,
                                )}`}</strong>
                            </div>
                        </Col>
                    </Row>

                    <Button
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            width: '100%',
                            fontSize: '16px',
                            backgroundColor: Palette.PRIMARY,
                            borderColor: Palette.PRIMARY,
                        }}
                        variant="primary"
                        className="mt-3 px-5 py-2"
                        href={`/tsn/${data.id}`}
                        size="lg"
                    >
                        Selengkapnya
                    </Button>
                </Card.Body>
            </Card>
        </Col>
    )

    const getCurrentData = () => {
        return activeTab === TAB_REGISTERED ? registeredTsnData : tsnData
    }

    const EmptyState = ({ type }) => (
        <div className="text-center py-5 w-100">
            <h5 className="mb-2" style={{ color: Palette.PRIMARY }}>
                {type === 'upcoming' ? 'Tidak Ada TSN Mendatang' : 'Belum Ada TSN Terdaftar'}
            </h5>
            <p className="text-muted mb-3">
                {type === 'upcoming'
                    ? 'Saat ini tidak ada TSN yang tersedia. Silakan cek kembali nanti.'
                    : 'Anda belum mendaftar ke TSN manapun.'}
            </p>
            {type === 'registered' && (
                <Button
                    variant="outline-primary"
                    onClick={() => setActiveTab(TAB_UPCOMING)}
                    style={{ borderColor: Palette.PRIMARY, color: Palette.PRIMARY }}
                >
                    Lihat TSN Mendatang
                </Button>
            )}
        </div>
    )

    const LoadingState = () => (
        <div className="text-center py-5 w-100">
            <div className="spinner-border" style={{ color: Palette.PRIMARY }} role="status"></div>
            <p className="text-muted mt-3">Memuat data TSN...</p>
        </div>
    )

    const renderTabContent = () => {
        if (loading) {
            return <LoadingState />
        }

        const currentData = getCurrentData()

        if (!currentData || currentData.length === 0) {
            return <EmptyState type={activeTab === TAB_UPCOMING ? 'upcoming' : 'registered'} />
        }

        return (
            <Row>
                {currentData.map((tsnObject) => (
                    <TsnCards key={tsnObject.id} data={tsnObject} />
                ))}
            </Row>
        )
    }

    return (
        <Container className="text-left py-4">
            <Tabs activeKey={activeTab} onSelect={handleTabSelect} className="mb-4">
                <Tab eventKey={TAB_UPCOMING} title="Mendatang">
                    {renderTabContent()}
                </Tab>

                <Tab eventKey={TAB_REGISTERED} title="Telah Terdaftar">
                    {renderTabContent()}
                </Tab>
            </Tabs>
        </Container>
    )
}
